import axios from "axios";
import environment from "../environment";
import Order from "../types/Order";
import {AccountInfo} from "../types/AccountInfo";
import {PaymentFreeMonthData} from "../types/PaymentFreeMonthData";

export async function startSigningProcess(hashId: string, body: Object) {
  const res = await axios.post<string>(environment.apiUrl + "/esign/start/" + hashId, body)
  console.log(res)
  return res.data;
}

export async function startCancelProcess(hashId: string) {
  const res = await axios.post<string>(environment.apiUrl + "/order/cancel/" + hashId)
  console.log(res)
  return res.data;
}

export async function getOrderInfo(hash: string): Promise<Order> {
  const res = await axios.get<Order>(environment.apiUrl + "/order/beforesign/" + hash)
  console.log(res)
  return res.data;
}

export async function getEKInfo(hash: string): Promise<AccountInfo> {
  const res = await axios.get<AccountInfo>(environment.apiUrl + "/order/beforeCancel/" + hash)
  console.log(res)
  return res.data;
}

export async function getEstimate(hash: string, amountOfPaymentFreeMonths: number | undefined | null): Promise<number | null> {
  let url = environment.apiUrl + "/order/estimate/" + hash
  if(amountOfPaymentFreeMonths)
    url += "?paymentFreeMonthCount=" + amountOfPaymentFreeMonths
  const res = await axios.get<number | null>(url)
  console.log(res)
  return res.data;
}

export async function getModifyPaymentFreeEstimate(hash: string, amountOfPaymentFreeMonths: number | undefined | null): Promise<number | null> {
  let url = environment.apiUrl + "/paymentFreeMonth/estimate/" + hash
  if(amountOfPaymentFreeMonths)
    url += "?paymentFreeMonthCount=" + amountOfPaymentFreeMonths
  const res = await axios.get<number | null>(url)
  console.log(res)
  return res.data;
}

export async function getOrderInfoAfterSign(hash: string): Promise<Order> {
  const res = await axios.get<Order>(environment.apiUrl + "/order/afterSign/" + hash)
  console.log(res)
  return res.data;
}

export async function getPaymentFreeData(hash: string): Promise<PaymentFreeMonthData> {
  const res = await axios.get<PaymentFreeMonthData>(environment.apiUrl + "/paymentFreeMonth/" + hash)
  console.log(res)
  return res.data;
}

export async function updatePaymentFreeMonths(hashId: string, months: number[]) {
  const res = await axios.post<string>(environment.apiUrl + "/paymentFreeMonth/" + hashId, months)
  console.log(res)
  return res.data;
}